const TextField = {
  sx: {
    '& .MuiOutlinedInput-root ': { pr: 2 }
  }
};

export default {
  TextField
};
